import { styles, variants, ReadonlyTextFieldTheme } from '../ReadonlyTextFieldStyles.css';
import { multiVariantStyles } from './ReadonlyTextFieldVariants.css';

const ReadonlyTextFieldStableTheme: ReadonlyTextFieldTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ReadonlyTextFieldStableTheme };
